let items = [];
let nextId = 1;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());
export function showErrorToast(message) {
    // Le même message déjà affiché n'est pas empilé une seconde fois.
    if (items.some((t) => t.message === message))
        return;
    const id = nextId++;
    items = [...items, { id, message }];
    emit();
    setTimeout(() => dismissErrorToast(id), 8000);
}
export function dismissErrorToast(id) {
    items = items.filter((t) => t.id !== id);
    emit();
}
export function subscribeErrorToast(listener) {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}
export const getErrorToasts = () => items;
